import { analyticsReducer } from "@vv/analytics-frontend";
import { auditLogReducer } from "@vv/audit-log-frontend";
import { configureStore } from "@reduxjs/toolkit";
import { notificationsReducer } from "@vv/notifications-frontend";
import { requestsReducer } from "@vv/requests-frontend";
import { teamsReducer } from "@vv/teams-frontend";
import { usersReducer } from "@vv/users-frontend";
import authReducer from "./auth/auth.slice";

export function createAppStore() {
  return configureStore({
    reducer: {
      auth: authReducer,
      teams: teamsReducer,
      requests: requestsReducer,
      users: usersReducer,
      notifications: notificationsReducer,
      auditLog: auditLogReducer,
      analytics: analyticsReducer,
    },
  });
}

export const store = createAppStore();

export type AppStore = typeof store;
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];
